// localStorage key used to override the `useConversationAnalysisV2` flag from
// the browser. Lets us toggle the V2 experience in any environment (where the
// injected dashboard config can't be edited) via:
//   localStorage.setItem('useConversationAnalysisV2', 'true')   // force on
//   localStorage.setItem('useConversationAnalysisV2', 'false')  // force off
//   localStorage.removeItem('useConversationAnalysisV2')        // use config
export const CONVERSATION_ANALYSIS_V2_STORAGE_KEY = 'useConversationAnalysisV2';

/**
 * Resolves whether the Conversation Analysis V2 experience is enabled.
 * A localStorage override (if present) takes precedence over the dashboard
 * config value, so it can force the flag on or off in any environment.
 */
export function isConversationAnalysisV2Enabled(configValue?: boolean): boolean {
  try {
    const stored = window.localStorage.getItem(CONVERSATION_ANALYSIS_V2_STORAGE_KEY);
    if (stored !== null) return stored === 'true';
  } catch {
    // localStorage may be unavailable (e.g. private mode) — fall back to config.
  }
  return configValue ?? false;
}
